import { render, staticRenderFns } from "./ProductCompareEditItem.vue?vue&type=template&id=21f810a3&scoped=true&"
import script from "./ProductCompareEditItem.vue?vue&type=script&lang=js&"
export * from "./ProductCompareEditItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductCompareEditItem.vue?vue&type=style&index=0&id=21f810a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f810a3",
  null
  
)

export default component.exports